import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";

export function broadcastRegister(token, api_token,data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/broadcaster/register?api_token=${api_token}`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data),
            types: [types.BROADCASTER_REGISTER_REQUEST, types.BROADCASTER_REGISTER_RECEIVE,{
                type: types.BROADCASTER_REGISTER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetBroadcastRegister = () => ({
    type: types.BROADCASTER_RESET_REGISTER,
    payload: null
});